module.exports = __webpack_public_path__ + "img/download-active.62898d7f.svg";